import type { ReactNode } from 'react';

import { Navigate } from 'react-router';

import { usePathname } from 'src/routes/hooks';

import { useAuthContext } from '../hooks';
import { MARKETING_HOME, isMarketingRole, isPathOpenToMarketing } from '../marketing-scope';

// ----------------------------------------------------------------------

/**
 * Keeps a MARKETING admin on the Marketing and Acquisition pages: any other
 * dashboard url (including `/dashboard` itself, where sign-in lands) redirects
 * to Marketing. Every other role passes straight through. See
 * `marketing-scope.ts` for why this is convenience, not the security boundary.
 */
export function MarketingScopeGuard({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const { user } = useAuthContext();

  if (isMarketingRole(user?.role) && !isPathOpenToMarketing(pathname)) {
    return <Navigate to={MARKETING_HOME} replace />;
  }

  return <>{children}</>;
}
